import React from 'react';
import {InputGroup, InputGroupText, InputGroupAddon, Input} from 'reactstrap';

const TextInputWithPrefix = React.forwardRef((props, ref) => {
    let formControl = 'text-input-with-prefix';
    let errorMsg = '';

    if (props.error && props.error.length > 0) {
        formControl = 'text-input-with-prefix input-error';
        errorMsg = props.error;
    }

    return (
        <div>
            <label className={`${formControl} has-float-${props.required ? 'label-required' : 'label'}`}>
                <Input innerRef={ref} name={props.name} {...props} />
                <span>{props.placeholder}</span>
                {props.prefixText && <div className="prefix-text"> {props.prefixText} </div>}

            </label>
            {errorMsg != '' &&
                <div className='error'>{errorMsg}</div>
            }
        </div>
    );
})

export default TextInputWithPrefix;
